import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./index.module.css";
import { CreateFileButton } from "../create-file-button";
export const ActionBar = ({ parentId = null, onProcessFinished = () => { }, }) => {
    return (_jsx("div", Object.assign({ className: styles.container }, { children: _jsx(CreateFileButton, { parentId: parentId, onProcessFinished: onProcessFinished }) })));
};
